export const MAPBOX_API_KEY =
	'pk.eyJ1IjoibXZlbGtlciIsImEiOiJjamVyZjVudHMzbjB5MzNtZWhldmp3cWx2In0.K4FnHyGBb8m7pedPYlaoiA';
export const GOOGLE_MAPS_API_KEY = 'AIzaSyCillR51a8cpJnmMkXgfWWljaLBqxFsmn8';
